import { useEffect, useState } from 'react';

const classNamePrefixChecker = prefix => {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return false;
  }

  return Array.from(document.body.classList).some(bodyClassName =>
    bodyClassName.startsWith(prefix),
  );
};

/**
 * Custom hook to watch for changes in the body class list and check for a specific class.
 *
 * @param {string} targetClass - The class name (or class name prefix) to watch for.
 * @returns {boolean} - Returns `true` if the class exists in the body, otherwise `false`.
 */
const useBodyClassWatcher = targetClass => {
  const [hasClass, setHasClass] = useState(classNamePrefixChecker(targetClass));

  useEffect(
    () => {
      if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
      }

      const observer = new MutationObserver(() => {
        const classExists = classNamePrefixChecker(targetClass);
        setHasClass(classExists);
      });

      observer.observe(document.body, {
        attributes: true,
        attributeFilter: ['class'],
      });

      // eslint-disable-next-line consistent-return
      return () => {
        observer.disconnect();
      };
    },
    [targetClass],
  );

  return hasClass;
};

export default useBodyClassWatcher;
